module.exports = __webpack_public_path__ + "media/fold.cc850a2a.mp3";